export default "__VITE_PUBLIC_ASSET__5fa4dd89__"